import { render, staticRenderFns } from "./haoka.vue?vue&type=template&id=2178ce6e&"
import script from "./haoka.vue?vue&type=script&lang=js&"
export * from "./haoka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports